import React from 'react'
import styled from 'styled-components'
import GD from '../GD'
import { messageStyles } from '../styles/messages'
import { textToHtml } from '../utils/Helpers'

// BOT COMMAND -----------------------
const MessageBotCommandDiv = styled.div`
  background-color: ${props => props.theme.color.main.messageMy};
  padding: ${props => props.theme.padding.chatMessage};
  border-radius: ${props => props.theme.borderRadius.chatMessage.regular};
`
export const MessageBotCommand = (params: { msg: IMessage }) => {
  return (
    <MessageBotCommandDiv data-type="message">
      {params.msg.sys?.title}
    </MessageBotCommandDiv>
  )
}

// BOT MENU ITEM -----------------------
const BotMenuItemDiv = styled.div`
  cursor: pointer;
  color: ${props => props.theme.color.main.messageBotButtonText};
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 9px 0 9px 0;
  &:first-child {
    border-top: none;
  }
  &:hover {
    text-decoration: underline;
  }
`

const BotMenuItem = (params: { data: BotMenuItem, userUID: string }) => {
  const { text, action } = params.data
  const onclick = () => {
    GD.CHAT_BOT_COMMAND_SEND_REQUEST.invoke({
      action: action,
      title: text,
      actionData: null,
      botUID: params.userUID,
    })
  }
  return <BotMenuItemDiv onClick={onclick}>{text}</BotMenuItemDiv>
}

// BOT MENU -----------------------
const MessageBotMenuTitlePre = styled.pre`
  margin-top: 0;
  margin-bottom: 2px;
  padding: ${props => props.theme.padding.chatMessage};
  background-color: ${props => props.theme.color.main.messagePartner};
  color: ${props => props.theme.color.main.messagePartnerText};
  border-radius: ${props => {
    const regularRadius = props.theme.borderRadius.chatMessage.regular
    const smallRadius = props.theme.borderRadius.chatMessage.small
    return `${regularRadius} ${regularRadius} ${regularRadius} ${smallRadius}`
  }};
  white-space: break-spaces;
  &:nth-last-child {
    background-color: green;
  }
`
const MessageBotMenuItemsDiv = styled.div`
  padding: ${props => props.theme.padding.chatMessage};
  background-color: ${props => props.theme.color.main.messagePartner};
  color: ${props => props.theme.color.main.messagePartnerText};
  border-radius: ${props => {
    const regularRadius = props.theme.borderRadius.chatMessage.regular
    const smallRadius = props.theme.borderRadius.chatMessage.small
    return `${smallRadius} ${regularRadius} ${regularRadius} ${regularRadius}`
  }};
  &::after {
    ${messageStyles.messageCloudTaleLeft}
  }
`

export const MessageBotMenu = (props: { data: SystemIMessage, msg: IMessage }) => {
  const data = props.msg.sys?.additionalData as BotAdditionalData
  const title: string | undefined = data.menu?.title

  let items: React.ReactElement[] | null = null

  if (data.menu && Array.isArray(data.menu.items)) {
    items = data.menu.items.map((val: BotMenuItem, idx) => <BotMenuItem data={val} userUID={props.msg.user_uid} key={idx} />)
  }

  return (
    <div>
      {title && <MessageBotMenuTitlePre dangerouslySetInnerHTML={{ __html: textToHtml(title) }} />}
      {items && <MessageBotMenuItemsDiv>{items}</MessageBotMenuItemsDiv>}
    </div>
  )
}

// FILE ---------------
const MessageFileDiv = styled.div<{ isBottomPanel: boolean }>`
  background-color: ${props => props.theme.color.main.fileMessage.background};
  padding: 10px;
  border-radius: ${props => props.theme.borderRadius.chatMessage.regular};
  display: flex;
  align-items: center;
  max-width: ${props => (props.isBottomPanel ? '100%' : 'calc(100% - 20px)')};
  width: ${props => (props.isBottomPanel ? '100%' : 'auto')};
  cursor: pointer;
  &::before {
    content: "";
    display: block;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAeklEQVRIie2UwRGAIAwEL45t2I+VUIdP65RCzo9+IEKIo+M47BPusvAJ8DtIziQj6yxewWYY7pecTUvmYH1a0CZxCuySGwJVIloZAEQku0szGmlvLL3UOqQkHTyCFrqgC7rgBYG2KiKAqbbwLojpgfaDoAWNw4Oj93F2ysfj8659GAAAAAAASUVORK5CYII=);
    width: 30px;
    height: 30px;
    min-width: 30px;
    min-height: 30px;
    background-color: ${props => props.theme.color.main.fileMessage.icon};
    background-repeat: no-repeat;
    background-position: center;
    background-size: 80%;
    border-radius: 8px;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
    margin-right: 10px;
  }
  &::after {
    content: attr(data-title);
    display: block;
    flex-grow: 1;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`
export const MessageFile = (params: { msg: IMessage, isBottomPanel?: boolean }) => {
  const onFileClick = () => {
    if (params.msg.sys && params.msg.sys.additionalData)
      GD.FILE_DOWNLOAD_REQUEST.invoke({
        uid: params.msg.sys.additionalData as string,
        name: params.msg.sys.title!,
      })
  }
  return (
    <MessageFileDiv
      data-title={params.msg.sys?.title}
      onClick={onFileClick}
      isBottomPanel={params.isBottomPanel ? params.isBottomPanel : false}>
    </MessageFileDiv>
  )
}
